import { Pill } from '~/_shared/baseComponents/pill/pill.component';
import { TooltipComponent } from '~/_shared/baseComponents/tooltip/tooltip.component';
import { useTheme } from '~/_shared/themes/theme.hooks';
import { useTranslation } from '~/_shared/utils/hooks';

type MetricInferenceSourceDataLayerTagProps = {
  readonly onDataLayerClick: () => void;
};

export const MetricInferenceSourceDataLayerTagComponent = ({
  onDataLayerClick,
}: MetricInferenceSourceDataLayerTagProps) => {
  const [t] = useTranslation();
  const theme = useTheme();

  return (
    <TooltipComponent tooltipContent={t('metricSource.inferredDataLayers')}>
      <Pill
        backgroundColor={theme.backgroundColors.secondaryAlternative}
        textColor={theme.textColors.primary}
        onClick={onDataLayerClick}
        role="button"
        tabIndex={0}
      >
        {t('dataLayersTool.dataLayer')}
      </Pill>
    </TooltipComponent>
  );
};
